import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/Layout";
import LayoutNoSidebar from "../views/layout/LayoutNoSidebar";
import LayoutNoheaderandsidebar from "../views/layout/LayoutNoheaderandsidebar.vue";

Vue.use(VueRouter);

//only routes for which privileges are not required
export const constantRouterMap = [
  {
    path: "/login",
    // name:"keycloaklogin",
    component: () => import("@/views/login/LoginPage.vue"),
  },
  {
    path: "/registration",
    component: LayoutNoSidebar,
    redirect: "/registration",
    children: [
      {
        path: "/",
        name: "Registration",
        component: () =>
          import("@/views/StudentRegistration/Studentregistration.vue"),
        meta: {
          title: "Registration",
        },
      },
    ],
  },
  // external panel
  // {
  //   path: "/registration",
  //   component: LayoutNoSidebar,
  //   redirect: "/registration",
  //   children: [
  //     {
  //       path: "/",
  //       name: "NewJobRegistration",
  //       component: () =>
  //         import("@/views/JobsRegistration/NewJobRegistration.vue"),
  //       meta: {
  //         title: "JobsRegistration",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/resumechecker",
    component: LayoutNoSidebar,
    redirect: "/resumechecker",
    children: [
      {
        path: "/",
        name: "ResumeChecker",
        component: () => import("@/views/resumeChecker/resumeChecker.vue"),
        meta: {
          title: "ResumeChecker",
        },
      },
    ],
  },
  {
    path: "/externalpanel",
    component: LayoutNoheaderandsidebar,
    redirect: "/externalpanel",
    children: [
      {
        path: "/",
        name: "externalpanel",
        component: () => import("@/views/panelLogin/Externalpanel.vue"),
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile",
    children: [
      {
        path: "/",
        name: "Profile",
        component: () => import("@/views/AccountSettings/ProfileRouting.vue"),
        meta: {
          title: "Profile",
        },
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile",
    children: [
      {
        path: "/",
        name: "MobileProfile",
        component: () => import("@/views/AccountSettings/ProfileRouting.vue"),

        meta: {
          title: "Profile",
        },
      },
    ],
  },
  {
    path: "/forgot",
    component: () => import("../views/login/Forgotpassword.vue"),
  },
  // {
  //   path: "/registration",
  //   component: LayoutNoheaderandsidebar,
  //   redirect: "/registration",
  //   children: [
  //     {
  //       path: "/",
  //       name: "Registration",
  //       component: () =>
  //         import("@/views/StudentRegistration/Studentregistration.vue"),
  //       meta: {
  //         title: "Registration",
  //       },
  //     },
  //   ],
  // },

  {
    path: "/JobRegistration/:jobID",
    component: LayoutNoSidebar,
    children: [
      {
        path: "/",
        name: "JobRegistration",
        component: () =>
          import("@/views/JobsRegistration/NewJobRegistration.vue"),
        meta: {
          title: "Register",
        },
      },
      {
        path: "/jobnotfound",
        name: "JobNotFound",
        component: () => import("@/views/error/jobNotFound.vue"),
      },
    ],
  },
  {
    path: "/jobs",
    component: Layout,
    children: [
      {
        path: "paneldetails",
        name: "PanelDetails",
        component: () => import("@/views/routing/ExternalPanel.vue"),
        meta: {
          title: "Panel Details",
          // roles: ["GET_JOBDASHBOARD"],
        },
      },
    ],
  },

  {
    path: "/sucess",
    component: LayoutNoSidebar,
    children: [
      {
        path: "/",
        name: "FareWellPage",
        component: () =>
          import("@/views/LinkCandidateRegistration/FareWellPage"),
        meta: {
          title: "FareWellPage",
        },
      },
    ],
  },
  {
    path: "/client-dashboard",
    component: Layout,
    children: [
      {
        path: "/",
        name: "ClientDashboard",
        component: () => import("@/views/VendorClient/ClientDashboard.vue"),
        meta: {
          title: "Home",
        },
      },
    ],
  },
];

export const asyncRoutes = [
  {
    path: "/jobdashboard",
    component: Layout,
    meta: {
      roles: ["RECRUITER_VIEW", "JOB_VIEW"],
    },
    children: [
      {
        path: "/",
        name: "JobDashboard",
        component: () => import("../views/JobDashboard/JobDashboard.vue"),
      },
    ],
  },
  {
    path: "/documents",
    component: Layout,
    meta: {
      roles: ["GET_DOCUMENT"],
    },
    children: [
      {
        path: "/",
        name: "Documents",
        component: () => import("../views/HRDocuments/Documents.vue"),
      },
    ],
  },
  {
    path: "/transactions",
    component: Layout,
    meta: {
      roles: ["GET_TRANSACTIONS"],
    },
    children: [
      {
        path: "/",
        name: "Transactions",
        component: () => import("../views/Transactions/Transactions.vue"),
        meta: {
          title: "Transactions",
        },
      },
    ],
  },
  {
    path: "/report",
    component: Layout,
    meta: {},
    children: [
      {
        path: "/",
        name: "ReportDashboard",
        component: () => import("@/views/ReportsNew/Reports.vue"),
        meta: {
          roles: [
            "GET_REPORT_CUSTOMER",
            "GET_REPORT_RECRUITER",
            "GET_REPORT_PANELIST",
            "GET_REPORT_VENDOR",
            "GET_REPORT_MANAGEMENT",
          ],
          title: "Reports",
        },
      },
      {
        path: "customer-reports",
        name: "CustomerReport",
        component: () => import("@/views/ReportsNew/CustomerReports.vue"),
        meta: {
          title: "Customer Reports",
          roles: ["GET_REPORT_CUSTOMER"],
        },
      },
      {
        path: "recruiter-reports",
        name: "RecruiterReport",
        component: () => import("@/views/ReportsNew/RecruiterReports.vue"),
        meta: {
          title: "Recruiter Reports",
          roles: ["GET_REPORT_RECRUITER"],
        },
      },
      {
        path: "vendor-reports",
        name: "VendorReport",
        component: () => import("@/views/ReportsNew/VendorReports.vue"),
        meta: {
          title: "Vendor Reports",
          roles: ["GET_REPORT_VENDOR"],
        },
      },
      {
        path: "panelist-reports",
        name: "PanelistReport",
        component: () => import("@/views/ReportsNew/PanelistReports.vue"),
        meta: {
          title: "Panelist Reports",
          roles: ["GET_REPORT_PANELIST"],
        },
      },
    ],
  },
  {
    path: "/jdflow",
    component: Layout,
    meta: {
      title: "Kanban",
    },
    children: [
      {
        path: "kanban",
        name: "Kanban",
        component: () => import("@/views/Jdflow/Kanban.vue"),
        meta: {
          title: "Kanban View",
          roles: ["GET_JOBDASHBOARD"],
        },
      },
      {
        path: "viewcandidatedocs",
        name: "viewcandidatedocs",
        component: () => import("@/views/Jdflow/ViewDocs.vue"),
      },
      {
        path: "cvSearchKanban",
        name: "cvSearchKanban",
        component: () => import("@/views/cvsearch/CvSearch"),
        meta: {
          title: "Search Profiles",
          roles: ["GET_CV_SEARCH"],
        },
      },
      {
        path: "analytics",
        name: "Analytics",
        component: () => import("@/views/jobs/Reports.vue"),
      },
      {
        path: "onboardingdocuments/:jobID/:candidateID",
        name: "OnboardingDocuments",
        component: () => import("@/views/OnboardingDocuments/Documents.vue"),
        meta: {
          roles: ["VIEW_ONBOARDING_DOCS"],
        },
      },
      {
        path: "botanalysis",
        name: "BotAnalysis",
        component: () => import("@/views/botanalysis/BotAnalysis.vue"),
        meta: {
          title: "Candidate Analysis",
          roles: ["VIEW_CANDIDATE_ANALYSIS"],
        },
      },
    ],
  },
  {
    path: "/vendorlogin",
    component: Layout,
    redirect: "/vendorlogin/vendordashboard",
    meta: {
      title: "Clients",
      roles: ["GET_VENDOR_DASHBOARD"],
      // title: "Assign JD's",
    },
    children: [
      {
        path: "kanban/:vendorID/:client",
        name: "VendorKanban",
        component: () => import("@/views/VendorFlow/VendorKanban.vue"),
      },
      {
        path: "vendordashboard",
        name: "clientdashboard",
        component: () => import("@/views/VendorFlow/VendorClientDashboard.vue"),
      },
      {
        path: "jobs/:vendorID/:client",
        name: "jobs",
        component: () => import("@/views/VendorFlow/VendorJobs"),
      },
      {
        path: "addcandidate",
        name: "AddCandidateInVendor",
        component: () => import("@/views/candidate/AddCandidate"),
        meta: {
          title: "Add Candidate",
        },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/workbench",
    meta: {
      title: "Workbench",
    },
    children: [
      {
        path: "workbench",
        name: "workBench",
        component: () => import("@/views/workbench/workBench"),
        meta: {
          // title: "Dashboard",
          roles: ["GET_WORKBENCH"],
        },
      },
    ],
  },
  {
    path: "/jobs",
    component: Layout,
    name: "Internal Hiring",
    meta: {
      // title: "Internal Hiring",
    },
    children: [
      {
        path: "board/:cardName/:customerID",
        name: "InternalHiringDashboard",
        component: () => import("@/views/jobs/InternalHiringDashboard"),
        meta: {
          title: "Jobs",
          roles: ["GET_JOB"],
        },
      },
      {
        path: "jddetails",
        name: "JdDetails",
        component: () => import("@/views/jobs/JdDetails"),
        meta: {
          title: "Job Dashboard",
          // roles: ["GET_JOBDASHBOARD"],
        },
      },
      {
        path: "applicationtable",
        name: "ApplicationTable",
        component: () => import("@/views/jobs/ApplicationTable"),
        meta: {
          title: "Applications",
        },
      },
      {
        path: "applicationpreview",
        name: "ApplicationPreview",
        component: () => import("@/views/jobs/ApplicationPreview"),
        meta: {
          title: "Candidate Details",
        },
      },
      {
        path: "requiredcandidatedocuments",
        name: "viewRequiredCandidateDocs",
        component: () => import("@/views/jobs/viewRequiredCandidateDocs"),
        meta: {
          title: "Approve Candidate Documents",
          // roles: ["GET_JOBDASHBOARD"],
        },
      },
      {
        path: "paneldetails",
        name: "PanelDetails",
        component: () => import("@/views/routing/ExternalPanel.vue"),
        meta: {
          title: "Panel Details",
          // roles: ["GET_JOBDASHBOARD"],
        },
      },
      {
        path: "createjob",
        name: "CreateJob",
        component: () => import("@/views/jobs/Job"),
        meta: {
          roles: ["PUSH_JOB", "EXTERNAL_ACCESS"],
        },
      },
    ],
  },
  {
    path: "/my-board",
    redirect: "/my-board/dashboard",
    component: Layout,
    children: [
      {
        path: "dashboard",
        name: "MainDashboard",
        component: () => import("@/views/Dashboard/MainDashboard.vue"),
        meta: {
          title: "Dashboard",
          roles: ["VIEW_DASHBOARD"],
        },
      },
    ],
  },

  {
    path: "/teams",
    component: Layout,
    meta: {
      roles: ["GET_TEAMS"],
    },
    children: [
      {
        path: "/",
        name: "Teams",
        component: () => import("@/views/Teams/Teams.vue"),
        meta: {
          title: "Teams",
        },
      },
    ],
  },

  {
    path: "/approval",
    redirect: "/approval/viewjds",
    component: Layout,
    children: [
      {
        path: "viewjds",
        name: "ViewJds",
        component: () => import("@/views/OpsheadJdApproval/ViewJds"),
        meta: {
          title: "Review Jobs",
          roles: ["GET_JD_APPROVAL"],
        },
      },
      // FOR CANDIDATES DETAIL VIEW IN CANDIDATE APPROVAL ( OPSHEAD )
      {
        path: "reviewcandidates",
        name: "ReviewCandidates",
        component: () =>
          import("@/views/OpsheadCandidatePortal/OpsheadCandDashboard"),
        meta: {
          title: "Review Candidates",
          roles: ["GET_ACCEPT_CANDIDATE"],
        },
      },
      {
        path: "viewcandidatestatus/:email/:jobID",
        name: "ViewCandidateStatus",
        component: () =>
          // import("@/views/OpsheadCandidatePortal/ViewCandidateStatus"),
          import("@/views/OpsheadCandidatePortal/ViewCandidateStatus"),
        meta: {
          title: "Candidate Details",
          roles: ["GET_ACCEPT_CANDIDATE"],
        },
      },
      {
        path: "viewcandidatejobprofile/:email",
        name: "PreviewOpsheadCandidateProfile",
        component: () => import("@/views/cvsearch/ViewCandidateProfile"),
        meta: {
          title: "Candidate Profile",
          roles: ["GET_PROFILE"],
        },
      },
    ],
  },

  {
    path: "/data",
    redirect: "/data/manage",
    component: Layout,
    meta: {
      // title: "Manage",
    },
    children: [
      {
        path: "manage",
        name: "Manage",
        component: () => import("@/views/manage/Manage"),
        meta: {
          // title: "Dashboard",
          roles: ["GET_CUSTOMER", "GET_VENDOR"],
        },
      },
      {
        path: "addcustomer",
        name: "AddCustomer",
        component: () => import("@/views/manage/customer/AddCustomer"),
        meta: {
          title: "Add Customer",
          roles: ["PUSH_CUSTOMER"],
        },
      },
      {
        path: "editcustomer/:customerID/:type",
        name: "EditCustomer",
        component: () => import("@/views/manage/customer/EditCustomer"),
        meta: {
          title: "Edit Customer",
          roles: ["PUT_CUSTOMER"],
        },
      },
      {
        path: "activatecustomer/:customerID/:type",
        name: "ActivateCustomer",
        component: () => import("@/views/manage/customer/EditCustomer"),
        meta: {
          title: "Activate Customer",
          roles: ["PUSH_CUSTOMER"],
        },
      },
      {
        path: "addvendor",
        name: "AddVendor",
        component: () => import("@/views/manage/vendor/AddVendor"),
        meta: {
          title: "Add Vendor",
          roles: ["PUSH_VENDOR"],
        },
      },
      {
        path: "editvendor/:vendorID/:type",
        name: "EditVendor",
        component: () => import("@/views/manage/vendor/EditVendor"),
        meta: {
          title: "Edit Vendor",
        },
      },
      {
        path: "activatevendor/:vendorID/:type",
        name: "ActivateVendor",
        component: () => import("@/views/manage/vendor/EditVendor"),
        meta: {
          title: "Activate Vendor",
        },
      },
    ],
  },
  {
    path: "/talentpool",
    // redirect: "/talentpool",
    component: Layout,
    meta: {
      title: "Talent Pool",
      roles: ["GET_TALENTPOOL"],
    },
    children: [
      {
        path: "/",
        name: "TalentPool",
        component: () => import("@/views/talentpool/TalentPool"),

        meta: {
          // title: "Dashboard",
          roles: ["GET_TALENTPOOL"],
        },
      },
      {
        path: "addcandidate",
        name: "AddCandidate",
        component: () => import("@/views/candidate/AddCandidate"),
        meta: {
          title: "Create Candidate",
        },
      },
      {
        path: "editcandidate/:candidateID",
        name: "EditCandidate",
        component: () => import("@/views/candidate/EditCandidate"),
        meta: {
          title: "Edit Candidate",
        },
      },
      {
        path: "activatecandidate/:candidateID",
        name: "ActivateCandidate",
        component: () => import("@/views/candidate/EditCandidate"),
        meta: {
          title: "Activate Candidate",
        },
      },
      {
        path: "cvSearchTalentPool",
        name: "cvSearchTalentPool",
        component: () => import("@/views/cvsearch/CvSearch"),
        meta: {
          title: "Search Profiles",
          roles: ["GET_CV_SEARCH"],
        },
      },
    ],
  },
  {
    path: "/givefeedback/:id",
    component: Layout,
    redirect: "/givefeedback",
    meta: {
      roles: ["PROFILE_SCREENING"],
    },
    children: [
      {
        path: "/",
        name: "GiveFeedback",
        component: () => import("@/views/ProfilesApproval/GiveFeedback.vue"),
        meta: {
          title: "Resume Screening",
        },
      },
    ],
  },
  {
    path: "/panellogin",
    component: Layout,
    meta: {
      roles: ["GET_PANEL_DASHBOARD"],
    },
    children: [
      {
        path: "/",
        name: "PanelLogin",
        component: () => import("@/views/routing/panelist.vue"),

        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "/paneldetails",
        name: "mobpanelDetails",
        component: () => import("../views/panelLogin/mobPanel.vue"),

        meta: {
          title: "panelDetails",
        },
      },
      {
        path: "/resumescreening",
        name: "mobresumeScreening",
        component: () => import("../views/panelLogin/mobResumescreening.vue"),

        meta: {
          title: "panelDetails",
        },
      },
      {
        path: "CandidateDetails",
        name: "CandidateDetails",
        component: () => import("../views/panelLogin/CandidateDetails.vue"),

        meta: {
          title: "CandidateDetails",
        },
      },
      {
        path: "GiveFeedbackForm",
        name: "GiveFeedbackForm",
        component: () => import("../views/panelLogin/GiveFeedbackForm.vue"),

        meta: {
          title: "GiveFeedbackForm",
        },
      },
    ],
  },

  // {
  //   path: "/vendorlogin",
  //   component: Layout,
  //   redirect: "/vendorlogin/vendordashboard",
  //   meta: {
  //     roles: ["GET_VENDOR_DASHBOARD"],
  //     // title: "Assign JD's",
  //   },
  //   children: [
  //     {
  //       path: "vendordashboard",
  //       name: "vendorDashboard",
  //       component: () => import("../views/vendorJDs/VendorjdDashboard.vue"),
  //       // props:true,
  //       meta: {
  //         title: "Assign JD's",
  //       },
  //     },
  //     {
  //       path: "vendorcandidates/:jobID/:customerID/:title",
  //       name: "vendorCandidates",
  //       component: () => import("../views/vendorJDs/VendorCandidates.vue"),
  //       // props:true,
  //       meta: {
  //         title: "Job Dashboard",
  //       },
  //     },
  //     {
  //       path: "addcandidatevendor",
  //       name: "AddCandidateInVendor",
  //       component: () => import("@/views/candidate/AddCandidate"),
  //       meta: {
  //         title: "Add Candidate",
  //       },
  //     },
  //     {
  //       path: "editcandidatevendor/:candidateID",
  //       name: "EditCandidateInVendor",
  //       component: () => import("@/views/candidate/EditCandidate"),
  //       meta: {
  //         title: "Edit Candidate",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/search",
    component: Layout,
    redirect: "/search",
    children: [
      {
        path: "profiles",
        name: "cvSearch",
        component: () => import("@/views/cvsearch/CvSearch"),
        meta: {
          title: "Search Profiles",
          roles: ["GET_CV_SEARCH"],
        },
      },
      {
        path: "searchcandidate",
        name: "SearchCandidate",
        component: () => import("@/views/cvsearch/SearchCvCandidate"),
        meta: {
          title: "Search Candidate",
          roles: ["GET_CV_SEARCH"],
        },
      },
      {
        path: "bookmarkedcandidates",
        name: "BookmarkedCandidates",
        component: () => import("@/views/cvsearch/BookmarkedCandidates"),
        meta: {
          title: "Bookmarked Candidates",
          roles: ["GET_CV_SEARCH"],
        },
      },
      // {
      //   path: "viewcandidateprofile/:email",
      //   name: "View",
      //   component: () => import("@/views/cvsearch/ViewCandidateProfile"),
      //   meta: {
      //     title: "Candidate Profile",
      //   },
      // },
      {
        path: "viewcandidateprofile/:email",
        name: "ViewCandidateProfile",
        component: () => import("@/views/cvsearch/ViewCandidateProfile"),
        meta: {
          title: "Candidate Profile",
          roles: ["GET_PROFILE"],
        },
      },
      {
        path: "addfromthirdparty",
        name: "AddFromThirdParty",
        component: () => import("@/views/cvsearch/AddToTalentPool"),
        meta: {
          title: "Add From Third Party",
          roles: ["GET_CV_SEARCH"],
        },
      },
    ],
  },

  {
    path: "/permission",
    component: Layout,
    redirect: "/permission/access",
    meta: {
      roles: [
        "admin",
        "SUB_ADMIN",
        "VIEW_ADMIN",
        "GET_ROLE",
        "GET_PANEL",
        "PUSH_PANEL",
      ],
    },
    children: [
      {
        path: "access",
        name: "AccessControl",
        component: () => import("@/views/admin/AccessControl"),
        meta: {
          title: "User Management",
          roles: ["SUB_ADMIN", "VIEW_ADMIN", "GET_ROLE"],
        },
      },

      {
        path: "panel/list",
        name: "Panellist",
        component: () => import("@/views/panel/Panellist"),
        meta: {
          title: "Panelists",
          roles: ["GET_PANEL"],
        },
      },
      {
        path: "addpanel",
        name: "AddPanel",
        component: () => import("@/views/panel/AddPanel"),
        meta: {
          title: "Add Panelist",
          roles: ["PUSH_PANEL"],
        },
      },
      {
        path: "editpanel/:panelID",
        name: "EditPanel",
        component: () => import("@/views/panel/EditPanel"),
        meta: {
          title: "Edit Panelist",
        },
      },
    ],
  },
  {
    path: "/addcandidate",
    component: Layout,
    children: [
      {
        path: "/",
        name: "AddCandidateInJD",
        component: () => import("@/views/candidate/AddCandidate"),
        meta: {
          title: "Add Candidate",
        },
      },
      {
        path: "editcandidate/:candidateID",
        name: "EditCandidateInJD",
        component: () => import("@/views/candidate/EditCandidate"),
        meta: {
          title: "Edit Candidate",
        },
      },
    ],
  },

  {
    path: "/hiringprocess",
    redirect: "/hiringprocess/dashboard",
    component: Layout,
    meta: {
      // title: "Interview Process",
    },
    children: [
      {
        path: "dashboard",
        name: "HiringProcessDashboard",
        component: () => import("@/views/HiringProcess/HiringProcess"),
        meta: {
          // title: "Dashboard",
          roles: ["GET_INTERVIEW", "GET_FEEDBACK_FORM"],
        },
      },

      {
        path: "feedbackform",
        name: "Feedbackform",
        component: () => import("@/views/InterviewProcess/Feedbackform"),
        meta: {
          title: "Create Feedback Form",
          roles: ["PUSH_FEEDBACK_FORM"],
        },
      },

      {
        path: "editfeedbackform/:feedbackFormID/:type",
        name: "EditFeedbackform",
        component: () => import("@/views/InterviewProcess/Feedbackform"),
        meta: {
          title: "Edit Feedback Form",
        },
      },
      {
        path: "activatefeedbackform/:feedbackFormID/:type",
        name: "ActivateFeedbackForm",
        component: () => import("@/views/InterviewProcess/Feedbackform"),
        meta: {
          title: "Activate Feedback Form",
        },
      },

      {
        path: "activate/:interviewProcessID",
        name: "ActivateInterview",
        component: () =>
          import("@/views/InterviewProcess/CreateInterviewProcess"),
        meta: {
          title: "Activate Interview Process",
        },
      },
      {
        path: "createinterviewprocess",
        name: "CreateInterviewProcess",
        component: () =>
          import("@/views/InterviewProcess/CreateInterviewProcess"),
        meta: {
          title: "Create Interview Process",
        },
      },
      {
        path: "editinterviewprocess/:interviewProcessID",
        name: "EditInterviewProcess",
        component: () =>
          import("@/views/InterviewProcess/CreateInterviewProcess"),
        meta: {
          title: "Edit Interview Process",
        },
      },
    ],
  },
  {
    path: "/previewfeedbackform",
    redirect: "/previewfeedbackform/dashboard",
    component: Layout,
    meta: {
      // title: "Feedback Forms",
      roles: ["GET_FEEDBACK_FORM"],
    },
    children: [
      {
        path: "dashboard",
        name: "PreviewFeedbackform Dashboard",
        component: () => import("@/views/InterviewProcess/PreviewFeedbackForm"),
        meta: {
          // title: "Dashboard",
          roles: ["GET_FEEDBACK_FORM"],
        },
      },
      {
        path: "feedbackform",
        name: "Feedbackform Dashboard",
        component: () => import("@/views/InterviewProcess/Feedbackform"),
        meta: {
          title: "Add Feedback Form",
        },
      },
    ],
  },
  {
    path: "/hr",
    component: Layout,
    // meta: {
    //   roles: ["GET_HRPORTAL"],
    // },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/HRmodule/Dashboard"),
        meta: {
          title: "HR Portal",
          roles: ["GET_HRPORTAL"],
        },
      },
      {
        path: "selectedcandidates",
        name: "SelectedCandidates",
        component: () => import("@/views/HRmodule/SelectedCandidates"),
        meta: {
          title: "Shortlisted Candidates",
          roles: ["GET_HRPORTAL"],
        },
      },
      {
        path: "upload-documents",
        name: "Uploaddocuments",
        component: () => import("@/views/HRmodule/Onboarding/UploadDocuments"),
        meta: {
          title: "Upload Documents",
        },
      },
      // {
      //   path: "OfferLetter/:candidateID",
      //   name: "OfferLetter",
      //   component: () => import("@/views/HRmodule/OfferLetter"),
      //   meta: {
      //     title: "OfferLetter",
      //   },
      // },

      // generate offer letter path
      {
        path: "offerletter/:candidateID",
        name: "OfferLetter",
        component: () => import("@/views/HRmodule/OfferLetter"),
        meta: {
          title: "Offer Letter",
        },
      },
      {
        path: "editofferletter/:candidateID",
        name: "EditOfferLetter",
        component: () => import("@/views/HRmodule/EditOfferLetter"),
        meta: {
          title: "Edit Offer Letter",
        },
      },
      {
        path: "templatesofferletter",
        name: "TemplatesOfferLetter",
        component: () => import("@/views/HRmodule/TemplatesOfferLetter"),
        meta: {
          title: "Templates",
        },
      },
      {
        path: "appointmentletter/:candidateID",
        name: "AppointmentLetter",
        component: () => import("@/views/HRmodule/AppointmentTemplate"),
        meta: {
          title: "Appointment Letter",
        },
      },
      // {
      //   path: "TemplatesOfferLetter/:candidateID",
      //   name: "TemplatesOfferLetter",
      //   component: () => import("@/views/HRmodule/TemplatesOfferLetter"),
      //   meta: {
      //     title: "Templates",
      //   },
      // },
      {
        path: "previewofferletter",
        name: "PreviewOfferLetter",
        component: () => import("@/views/HRmodule/PreviewOfferLetter"),
        meta: {
          title: "Preview Offer Letter",
        },
      },
      {
        path: "candidatedetails/:candidateID",
        name: "Candidate Details",
        component: () => import("@/views/HRmodule/candidateDetails"),
        meta: {
          title: "Candidate Details",
        },
      },
      {
        path: "hireemployee",
        name: "HireEmployee",
        component: () => import("@/views/HRmodule/HireEmployee"),
        meta: {
          title: "HireEmployee",
        },
      },
      {
        path: "viewcandidateofferdetails",
        name: "ViewCandidateOfferDetails",
        component: () => import("@/views/HRmodule/ViewCandidateOfferDetails"),
        meta: {
          title: "Candidate Offer Details",
        },
      },
      {
        path: "onboardingcandidates",
        name: "OnboardingCandidates",
        component: () =>
          import("@/views/HRmodule/Onboarding/OnboardingCandidates"),
        meta: {
          title: "Offer Letter Accepted",
        },
      },
      {
        path: "rejectedcandidates",
        name: "RejectedCandidates",
        component: () => import("@/views/HRmodule/RejectedCandidates"),
        meta: {
          title: "Rejected Candidates",
        },
      },
      {
        path: "sendappointment",
        name: "SendAppointment",
        component: () => import("@/views/HRmodule/SendAppointment"),
        meta: {
          title: "Appointment Letter",
        },
      },
      {
        path: "viewonboardingcandidate/:candidateID",
        name: "ViewOnboardingCandidate",
        component: () =>
          import("@/views/HRmodule/Onboarding/ViewOnboardingCandidate"),
        meta: {
          title: "Onboarding Candidate",
        },
      },
    ],
  },
  {
    path: "/thirdparty",
    component: Layout,
    children: [
      {
        path: "home",
        name: "ThirdParty",
        component: () => import("../views/thirdparty/thirdParty.vue"),
        meta: {
          title: "Third Party Integration",
          roles: ["GET_THIRD_PARTY"],
        },
      },
    ],
  },
  {
    path: "/bookmark",
    component: Layout,
    meta: {
      roles: ["BOOKMARK_TALENTPOOL_CANDIDATE"],
    },
    children: [
      {
        path: "/",
        name: "Bookmark",
        component: () => import("@/views/Bookmarks/Bookmarks.vue"),
        meta: {
          title: "Bookmarks",
        },
      },
    ],
  },

  {
    path: "/404",
    component: LayoutNoSidebar,
    children: [
      {
        path: "/",
        name: "404",
        component: () => import("@/views/error/PageNotFound"),
        meta: {
          title: "PageNotFound",
        },
      },
    ],
  },
  {
    path: "/customfield",
    component: Layout,
    meta: {
      roles: ["GET_FORM"],
    },
    children: [
      {
        path: "customform",
        name: "customform",
        component: () => import("@/views/CustomField/CustomForm"),
        meta: {
          title: "Custom Field",
        },
      },
      {
        path: "customtable",
        name: "customtable",
        component: () => import("@/views/CustomField/CustomTable"),
        meta: {
          title: "Search Profiles",
        },
      },
    ],
  },
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new VueRouter({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
const onError = (e) => {
  // avoid NavigationDuplicated
  if (e.name !== "NavigationDuplicated") throw e;
};

// keep original function
const _push = Object.getPrototypeOf(router).push;

// then override it
const newRouter = Object.create(router);
newRouter.push = function push(...args) {
  try {
    const op = _push.call(this, ...args);
    if (op instanceof Promise) op.catch(onError);
    return op;
  } catch (e) {
    onError(e);
  }
};
